import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import Evaluate from './components/Evaluate'
import MaturityModel from './components/MaturityModel'
import Methodology from './components/Methodology'
import Collect from './components/Collect'
import Act from './components/Act'
import Synthesize from './components/Synthesize'
import Adapt from './components/Adapt'
import GettingStarted from './components/GettingStarted'

import ogImage from './assets/OgImage.jpg'

const copy = {
  pageTitle: `Customer Data Maturity Model. Evaluate your data today! | Twilio Segment`,
  pageDescription: `Evaluate your company’s data strategy and we’ll give you actionable and personalized recommendations on how to improve with Twilio Segment’s Customer Data Maturity Model.`,
  evaluateTop: {
    heading: `Evaluate your data maturity in 5 minutes`,
    description: `Fill out the four question evaluation and we’ll give you actionable and personalized recommendations. It’s quick, easy, and helpful.`,
  },
  evaluateBottom: {
    heading: `Evaluate your data strategy today`,
    description: `Start the quiz below and we’ll help you identify if your customer data strategy is best-in-class.`,
  },
}

const CustomerDataMaturityView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={copy.pageTitle}
        pageDescription={copy.pageDescription}
        pageOG={ogImage}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Main>
          <Hero />
          <LogoCarousel />
          <Evaluate heading={copy.evaluateTop.heading} description={copy.evaluateTop.description} />
          <MaturityModel />
          <Methodology />
          <Collect />
          <Synthesize />
          <Act />
          <Adapt />
          <Evaluate heading={copy.evaluateBottom.heading} description={copy.evaluateBottom.description} />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default CustomerDataMaturityView
